import styled from "styled-components";

const Tile = styled.div`
  .card {
    max-width: 345px;
    min-height: 200px;
    margin: 10px;
  }
  .media {
    height: 0;
    padding-top: 30.25%;
  }
  .card-content {
    padding: 0;
  }
  td {
    width: 75px;
    padding: 10px;
  }
  .actions {
    background-color: #e0e0e0;
    position: relative;
    margin-top: -40px;
    height: 10em;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 5px 0;
  }
  .action-button {
    width: 50px;
    min-width: auto;
    height: 0;
  }
  .show {
    height: 30px;
    opacity: 1;
  }
  .hidden {
    height: 0;
    opacity: 0;
  }
  .card-content tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  .card-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    position: relative;
    margin-top: -50px;
    height: 30px;
    padding: 10px;
  }
  .card-overlay a {
    color: #0f9ad6;
    font-weight: bold;
    font-size: 17px;
    text-decoration: none;
  }
  .up {
    top: -40px;
    transition: top 0.3s linear;
  }
`;

export default Tile;
